import React from 'react';
import PropType from 'prop-types';
import {
  makeStyles, Paper,
} from '@material-ui/core';
import MetaControl from 'Components/UI/Meta/MetaControl';

const ESC_KEYCODE = 27;
const ENTER_KEYCODE = 13;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    margin: theme.spacing(0, 1, 0, 0),
    padding: theme.spacing(0, 1, 0, 0.25),
  },
  input: {
    margin: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    flex: 1,
    fontSize: 16,
    resize: 'none',
    border: 0,
    '&:focus': {
      outline: 0,
    },
  },
}));

export default function EditableContent({
  resource, value, onChange, onCancel, onSave,
}) {
  const classes = useStyles();

  const handleKeyPress = (e) => {
    if (e.which === ENTER_KEYCODE && !e.shiftKey) {
      e.preventDefault();
      onSave(e);
    }

    if (e.which === ESC_KEYCODE) {
      onCancel(e);
    }
  };

  return (
    <Paper className={classes.root}>
      <MetaControl
        resource={resource}
        attrName="content"
        onChange={onChange}
        value={value}
        fullWidth
        autoFocus
        className={classes.input}
        onKeyPress={handleKeyPress}
      />
    </Paper>
  );
}

EditableContent.propTypes = {
  resource: PropType.object.isRequired,
  value: PropType.string.isRequired,
  onCancel: PropType.func.isRequired,
  onSave: PropType.func.isRequired,
  onChange: PropType.func.isRequired,
};
